import axios from 'axios';

const deleteFarmer = (mobileNumber) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/farmer/deleteFarmer`, { mobileNumber })
    .then(res => res)
    .catch(err => err);
};

export default deleteFarmer;
